import React from "react";
import { Link, NavLink } from "react-router-dom";

import AccountMenu from "../auth/AccountMenu.jsx";
import { useSession } from "../context/SessionContext.jsx";
import { useUser } from "../hooks/useUsers";
import logo from "../assets/winvest-logo.svg";
import "./Header.css";

const Header = () => {
  const { currentUid } = useSession();
  const { user } = useUser(currentUid);
  
  const navClass = ({ isActive }) => (
    `header__link${isActive ? " header__link--active" : ""}`
  );

  return (
    <header className="header">
      <div className="header__inner">
        <Link to="/" className="header__logo" aria-label="WInvest home">
          <img src={logo} alt="" className="header__logo-img" width="120" height="28" />
        </Link>
        <nav aria-label="Main" className="header__nav">
          <NavLink to="/" end className={navClass}>Home</NavLink>
          {user && (
            <NavLink to={`/profile/${currentUid}`} className={navClass}>
              My profile
            </NavLink>
          )}
        </nav>
        <div className="header__spacer" />
        <AccountMenu profile={user} />
      </div>
    </header>
  );
};

export default Header;
